import http, { ResponseData } from './httpService'
import {
  IsaacMerchantLoginReqVO,
  IsaacMerchantRechargeReqVO,
  IsaacMerchantResVO,
  IsaacMerchantSignupReqVO,
  LotteryDrawResultVO,
  LotteryRecordVO,
  LotteryVO,
  MerchantPointRecordVO,
} from '../typings/merchant'
import { SaTokenInfo } from '../typings/user'
import { PageInterface } from '../typings/types'

export const signupMerchant = async (vo: IsaacMerchantSignupReqVO): Promise<void> => {
  await http.post<ResponseData<String>>('/fe/user/center/merchant/signup', vo)
}

export const recharge = async (param: IsaacMerchantRechargeReqVO): Promise<string> => {
  const { data } = await http.post<ResponseData<string>>('/fe/user/center/merchant/recharge', param)
  return data.data
}

export const loginMerchant = async (vo: IsaacMerchantLoginReqVO): Promise<SaTokenInfo> => {
  const { data } = await http.post<ResponseData<SaTokenInfo>>('/fe/user/center/merchant/login', vo)
  return data.data
}

export const merchantInfo = async (): Promise<IsaacMerchantResVO> => {
  const { data } = await http.get<ResponseData<IsaacMerchantResVO>>('/fe/user/center/merchant/info')
  return data.data
}

export const pointRecords = async (): Promise<MerchantPointRecordVO[]> => {
  const { data } = await http.post<ResponseData<PageInterface<MerchantPointRecordVO>>>(
    '/fe/user/center/merchant/pointRecords',
    {
      current: 1,
      pageSize: 100,
    }
  )
  return data.data.records
}

export const lotteryRecords = async (): Promise<LotteryRecordVO[]> => {
  const { data } = await http.post<ResponseData<PageInterface<LotteryRecordVO>>>(
    '/fe/user/center/merchant/lotteryRecords',
    {
      current: 1,
      pageSize: 100,
    }
  )
  return data.data.records
}

export const currentLottery = async (): Promise<LotteryVO> => {
  const { data } = await http.get<ResponseData<LotteryVO>>('/fe/user/center/merchant/lottery/current')
  return data.data
}

export const drawLottery = async (): Promise<LotteryDrawResultVO> => {
  const { data } = await http.post<ResponseData<LotteryDrawResultVO>>('/fe/user/center/merchant/lottery/draw')
  return data.data
}
